import PropTypes from 'prop-types'

const menuTitlePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  styledTitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  styledDescription: PropTypes.string,
  addonDescriptors: PropTypes.arrayOf(PropTypes.string),
  allergenDescriptors: PropTypes.arrayOf(PropTypes.string),
  dietDescriptors: PropTypes.arrayOf(PropTypes.string),
})

export default menuTitlePropType
